import axios from 'axios'

export const envApiUrl = process.env.REACT_APP_API_URL || `${document.location.origin}/api/`
const defaultApiUrl = `${window.location.protocol}//${window.location.hostname}`
const apiUrl = envApiUrl || defaultApiUrl

const axiosClient = axios.create({
  baseURL: `${apiUrl}`,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
})

axiosClient.interceptors.request.use(async (config: any) => {
  const customHeaders = {
    Authorization: '',
    'X-Locale': '',
  }

  const token = localStorage.getItem('access_token')
  const lang = localStorage.getItem('lang')
  if (lang) {
    customHeaders['X-Locale'] = lang
  }
  if (token) {
    customHeaders.Authorization = `Bearer ${token}`
  }

  return {
    ...config,
    headers: {
      ...customHeaders, // auto attach token
      ...config.headers, // but you can override for some requests
    },
  }
})

axiosClient.interceptors.response.use(
  (response: unknown) => {
    return response
  },
  (error: any) => {
    if (error.response.status === 401) {
      localStorage.removeItem('access_token')
      window.location.href = '/login'
    } else {
      throw error.response.data
    }
  },
)

export default axiosClient
